import { render, staticRenderFns } from "./EnvironmentContent.vue?vue&type=template&id=0c353f98&scoped=true"
import script from "./EnvironmentContent.vue?vue&type=script&lang=js"
export * from "./EnvironmentContent.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentContent.vue?vue&type=style&index=0&id=0c353f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c353f98",
  null
  
)

export default component.exports